import { StyleSheet } from 'react-native'

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  wraper_horizontal: {
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'center',
    alignSelf: 'center',
    flexGrow: 1,
    paddingHorizontal: 0,
  },
  wraper_vertical: {
    position: 'relative',
    marginRight: 16,
    flexDirection: 'column',
    flex: 1,
  },
  container_vertical: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'row',
  },
  container_horizontal: {
    flex: 1,
    flexDirection: 'column',
  },
  outer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 26,
    height: 26,
    backgroundColor: 'transparent',
    borderRadius: 20,
    borderWidth: 1,
    margin: 0,
  },
  outer_active: theme => ({
    borderColor: Colors.transparent,
  }),
  outer_current: theme => ({
    backgroundColor: 'transparent',
    borderColor: theme.colors.activeTabColorTwo,
  }),
  outer_inactive: theme => ({
    borderColor: Colors.transparent,
  }),
  inner: {
    alignSelf: 'center',
    alignContent: 'center',
    marginHorizontal: 2,
    width: 20,
    height: 20,
    borderRadius: 15,
  },
  inner_active: theme => ({
    backgroundColor: theme.colors.activeTabColorTwo,
  }),
  inner_current: theme => ({
    backgroundColor: theme.colors.activeTabColorTwo,
  }),
  inner_inactive: theme => ({
    backgroundColor: theme.colors.borderColorThree,
  }),
  text_container_vertical: {
    justifyContent: 'center',
    marginLeft: 16,
    flexGrow: 1,
  },
  text_container_horizontal: {
    alignItems: 'center',
    marginHorizontal: 0,
  },
  iconsContainer: {
    alignItems: 'center',
    marginBottom: 16,
    overflow: 'visible',
  },
  line_vertical: {
    position: 'absolute',
    height: '100%',
    width: 1,
    top: 20,
    left: '50%',
    zIndex: -1,
  },
  line_horizontal: {
    position: 'absolute',
    height: 1,
    width: '100%',
    top: '50%',
    left: '50%',
    zIndex: -1,
  },
  line_active: theme => ({
    backgroundColor: theme.colors.activeTabColorTwo,
  }),
  line_current: theme => ({
    backgroundColor: theme.colors.borderColorThree,
  }),
  line_inactive: theme => ({
    backgroundColor: theme.colors.borderColorThree,
  }),
  title: {
    margin: 0,
  },
  title_horizontal_active: {
    minWidth: 80,
    textAlign: 'center',
  },
  title_horizontal_inactive: {
    minWidth: 80,
    textAlign: 'center',
  },
  title_horizontal_current: {
    color: Colors.vfRed,
    minWidth: 80,
    textAlign: 'center',
    ...Fonts.type.bold,
  },
  desc: {
    color: Colors.thinDark,
    marginHorizontal: 0,
  },
  desc_vertical: {
  },
  desc_horizontal_current: {
    color: Colors.vfRed,
    ...Fonts.type.bold,
  },
})

export default styles
